import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../types/common.types';

import './spinner.scss';

const Spinner = () => {
  const spinners = useSelector((state: RootState) => state.system.spinners);

  if (!spinners || spinners.length === 0) return <Fragment />;

  return (
    <div className="spinner">
      <p>{spinners.at(-1)}...</p>
      <div className="spinner__ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default Spinner;
